import { useTranslation } from "react-i18next";

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <span className="text-xs font-semibold uppercase tracking-wider text-accent-600">
            {t("aboutEyebrow")}
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            {t("aboutTitle")}
          </h2>
          <div className="mt-5 space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            <p>{t("aboutP1")}</p>
            <p>{t("aboutP2")}</p>
            <p>{t("aboutP3")}</p>
          </div>
        </div>

        <div className="relative w-full h-64 md:h-80 rounded-lg overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20desk%20scene%20with%20a%20laptop%20displaying%20a%20colorful%20product%20spreadsheet%20table%20next%20to%20a%20folded%20beige%20sweater%2C%20a%20small%20potted%20succulent%20and%20a%20pair%20of%20glasses%20on%20a%20light%20oak%20wood%20desk%20against%20a%20soft%20off-white%20wall%2C%20bright%20natural%20daylight%20from%20a%20window%2C%20editorial%20minimalism%2C%20high%20detail%2C%20calm%20organized%20aesthetic&width=1000&height=750&seq=about-spreadsheet&orientation=landscape&nocache=true"
            alt="Basetao Spreadsheet organized research"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}